import { useState } from "react";
import { verifyLength } from "../../Service/Helper/Utils";
import MainButton from "../../Component/Button/MainButton";
import { CatchLoginError } from "../../Service/Exceptions/exceptions";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserService from "../../Service/API/UserService";
import LoadingScreen from "../../Component/Loader/LoadingScreen";
import logo from "../../public/img/logo.png";
import { Input } from "reactstrap";


function RegisterPages() {
    const [retypePass, setRetypePass] = useState('')
    const [searchParams] = useSearchParams()
    const navigation = useNavigate()
    const userService = new UserService()

    const id = searchParams.get('id')
    const [isLoad, setIsLoad] = useState(false)
    const [customerId, setCustomerId] = useState(id)
    const [password, setPassword] = useState('')
    const [visible, setVisible] = useState(false)
    const isUseParams = !id

    async function handleClick () {
        try {
            setIsLoad(true)
            const payload = {
                customerId,
                password,
                retypepassword: retypePass
            }

            await userService.register(payload)
            navigation(`/login?id=${customerId}`)
            setIsLoad(false)
        } catch (error) {
            setIsLoad(false)
            return CatchLoginError(error, navigation)
        }
    }
    const children = (
        <main className="public-auth-page">
            <section className="public-auth-hero">
                <div className="landing-container public-auth-grid">
                    <div className="public-auth-copy">
                        <div className="landing-brand-chip">
                            <img src={logo} alt="Goodnet Logo" />
                            <span>Goodnet By Artamedia</span>
                        </div>
                        <h1>Aktifkan akun pelanggan.</h1>
                        <p>Buat password untuk nomor layanan Anda agar bisa membuka tagihan dan metode pembayaran.</p>
                        <div className="landing-proof-grid">
                            <div><strong>Aman</strong><span>Data anda Terekripsi</span></div>
                            <div><strong>Cepat</strong><span>Registrasi Mudah</span></div>
                            <div><strong>Mudah</strong><span>Kelola tagihan</span></div>
                        </div>
                    </div>

                    <div className="public-auth-card">
                        <div className="public-auth-card-head">
                            <span>Register pelanggan</span>
                            <strong>BUat Password Anda</strong>
                        </div>

                        <div className="public-auth-form">
                            <Input
                                className="public-auth-input"
                                placeholder="Nomor Layanan (10 - 12) Digit"
                                value={customerId}
                                disabled={!isUseParams}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 13)) {
                                        setCustomerId(e.target.value)
                                    }
                                }}
                            />
                            <Input
                                className="public-auth-input"
                                placeholder="Masukkan Password"
                                value={password}
                                type={!visible ? "password" : "text"}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 16)) {
                                        setPassword(e.target.value)
                                    }
                                }}
                            />
                            <Input
                                className="public-auth-input"
                                placeholder="Konfirmasi Password"
                                value={retypePass}
                                type={!visible ? "password" : "text"}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 16)) {
                                        setRetypePass(e.target.value)
                                    }
                                }}
                            />
                        </div>

                        <div className="public-auth-link-row">
                            <button type="button" onClick={() => setVisible(!visible)}>
                                {visible ? "Sembunyikan Password" : "Tampilkan Password"}
                            </button>
                            <button type="button" onClick={() => navigation("/login")}>
                                Sudah punya akun
                            </button>
                        </div>

                        <div className="public-auth-actions">
                            <MainButton
                                title="Register"
                                onClick={handleClick}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )

    return (
        <>
            <LoadingScreen
                loading={isLoad}
                children={children}
            />
        </>
    )
}

export default RegisterPages;
